import { render, staticRenderFns } from "./AdministradorTicket.vue?vue&type=template&id=96a16cc6"
import script from "./AdministradorTicket.vue?vue&type=script&lang=js"
export * from "./AdministradorTicket.vue?vue&type=script&lang=js"
import style0 from "./AdministradorTicket.vue?vue&type=style&index=0&id=96a16cc6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports